// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1zTjM","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3vVTp"};